import React, { useState } from 'react'
import ButtonLayout from '../common/button/ButtonLayout'
import { FEEDBACK_BTN_STYLE } from '../../utils/GlobalConstants'
import DialogView from '../common/dialog/DialogView';
import { useMediaQuery, useTheme } from "@mui/material";
import ReportIssue from '../reportIssue/ReportIssue';
const FeedBack = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [reportIssue, setReportIssue] = useState(false);
    const handleOpenReportDialog = () => {
        setReportIssue(true);
    }
    const handleReportIssue = () => {
    setReportIssue(false);
  };
    return (<><DialogView
          from={"parts"}
          open={reportIssue}
          handleClose={() => handleReportIssue()}
          width={isMobile ? "70%" : "30%"}
          maxWidth={"75em!important"}
          heading={"Feedback"}
          testid={"reportIssue"}
          childComponet={<ReportIssue />}
        /><ButtonLayout
        label={"Feedback"}
        sx={{
            ...FEEDBACK_BTN_STYLE,
        }}
        onClickBtn={() => handleOpenReportDialog()}
        testid={"reportBtn"}
    /></>)
}
export default FeedBack